module.exports = __webpack_public_path__ + "static/media/Zygarde_gaussian2.7808187c.png";